export default "__VITE_ASSET__45a52d8a__"